import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=87e6bee8&"
import script from "./ProjectsList.vue?vue&type=script&lang=js&"
export * from "./ProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProjectsList.vue?vue&type=custom&index=0&blockType=styles&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports